/**
 * @generated SignedSource<<c5ace1c964dfb1d230c2ce317dc22a5e>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type ForumOwnerKind = "BLOG" | "COMPETITION" | "DATASET" | "EVENT" | "TOP_LEVEL" | "WORKSPACE";
import { DateTime } from "@/common/relayCustomScalar";
import { FragmentRefs } from "relay-runtime";
export type TopicListItemFragment$data = {
  readonly author: {
    readonly username: string;
    readonly " $fragmentSpreads": FragmentRefs<"EntityProfilePicFragment">;
  };
  readonly commentCount: number;
  readonly comments: {
    readonly nodes: ReadonlyArray<{
      readonly author: {
        readonly displayName: string;
        readonly username: string;
      };
      readonly createdAt: DateTime;
    }>;
  };
  readonly createdAt: DateTime;
  readonly forum: {
    readonly owner: {
      readonly events?: {
        readonly nodes: ReadonlyArray<{
          readonly event: {
            readonly slug: string;
          };
        }>;
      };
      readonly forumOwnerKind: ForumOwnerKind;
      readonly slug: string;
    };
    readonly slug: string;
  };
  readonly id: string;
  readonly title: string;
  readonly url: string | null | undefined;
  readonly viewerCanDelete: boolean;
  readonly " $fragmentSpreads": FragmentRefs<"VoteDisplayFragment">;
  readonly " $fragmentType": "TopicListItemFragment";
};
export type TopicListItemFragment$key = {
  readonly " $data"?: TopicListItemFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"TopicListItemFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v2 = {
  "kind": "Literal",
  "name": "first",
  "value": 1
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "username",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TopicListItemFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "url",
      "storageKey": null
    },
    (v0/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "commentCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Forum",
      "kind": "LinkedField",
      "name": "forum",
      "plural": false,
      "selections": [
        (v1/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "owner",
          "plural": false,
          "selections": [
            (v1/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "forumOwnerKind",
              "storageKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "alias": null,
                  "args": [
                    (v2/*:: as any*/)
                  ],
                  "concreteType": "EventCompetitionConnection",
                  "kind": "LinkedField",
                  "name": "events",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "EventCompetition",
                      "kind": "LinkedField",
                      "name": "nodes",
                      "plural": true,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "Event",
                          "kind": "LinkedField",
                          "name": "event",
                          "plural": false,
                          "selections": [
                            (v1/*:: as any*/)
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": "events(first:1)"
                }
              ],
              "type": "Competition",
              "abstractKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "author",
      "plural": false,
      "selections": [
        (v3/*:: as any*/),
        {
          "args": [
            {
              "kind": "Literal",
              "name": "thumbnail",
              "value": true
            }
          ],
          "kind": "FragmentSpread",
          "name": "EntityProfilePicFragment"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        (v2/*:: as any*/),
        {
          "kind": "Literal",
          "name": "order",
          "value": "NEWEST"
        }
      ],
      "concreteType": "CommentConnection",
      "kind": "LinkedField",
      "name": "comments",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Comment",
          "kind": "LinkedField",
          "name": "nodes",
          "plural": true,
          "selections": [
            (v0/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "User",
              "kind": "LinkedField",
              "name": "author",
              "plural": false,
              "selections": [
                (v3/*:: as any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "displayName",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "comments(first:1,order:\"NEWEST\")"
    },
    {
      "alias": "viewerCanDelete",
      "args": [
        {
          "kind": "Literal",
          "name": "action",
          "value": "DELETE_TOPIC"
        }
      ],
      "kind": "ScalarField",
      "name": "viewerCan",
      "storageKey": "viewerCan(action:\"DELETE_TOPIC\")"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "VoteDisplayFragment"
    }
  ],
  "type": "Topic",
  "abstractKey": null
};
})();

(node as any).hash = "7de673615caca5d948bf27e6216e2364";

export default node;
